// DoughForm defaults

import {unitGrams} from "../shared/Units";
import {formTypeWeightDough, LEVAIN_PCT_TYPE_TOTAL_WT, liquidLevain} from "../shared/Types";

const mainFormWeightDefaults = {
  formName: `New Formula`,
  formType: formTypeWeightDough,
  numBatches: 1,
  labels: [],
  attribution: '',
  includePreferment: false,
  prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
  pffBakersPct: false,
  prefermentData: undefined,
  process: {},
  starterAmount: 100,
  starterHydrationPct: 100,
  starterUnit: unitGrams,
  yeastAmount: 0,
  yeastUnit: unitGrams,
  flour: [
    {
      name: 'Bread Flour',
      id: 'b.1',
      amount: 500,
      unit: unitGrams
    }
  ],
  liquid: [
    {
      name: 'Water',
      amount: 350,
      unit: unitGrams,
      id: 'b.1'
    }
  ],
  mixin: [
    {
      name: 'Salt',
      id: 'b.1',
      amount: 10,
      unit: unitGrams
    }
  ],
  submixes: [
  ],
  toppings: [
  ],
  notes: ''
}

const prefermentWeightDefaults = {
  prefermentType: liquidLevain,
  autolyse: false,
  starterAmount: 0,
  starterHydrationPct: 100,
  starterUnit: unitGrams,
  yeastAmount: 0,
  yeastUnit: unitGrams,
  addBuffer: false,
  flour: [
    {
      name: 'All Purpose',
      id: 'b.1',
      amount: 100,
      unit: unitGrams
    }
  ],
  liquid: [
    {
      name: 'Water',
      amount: 100,
      unit: unitGrams,
      id: 'b.1'
    }
  ],
  mixin: []
}

export {mainFormWeightDefaults, prefermentWeightDefaults}